/* eslint-disable import/no-duplicates */
import { ptBR } from 'date-fns/locale';
import { format, getTime, isValid, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null | undefined;

export function fBrazilianDate(date: string | null | undefined, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';
  if (!date) return '';
  let dateAsDate = new Date(date);

  if (!date.includes('T')) {
    dateAsDate = new Date(`${date}T00:00:00`);
  }

  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, fm, { locale: ptBR });
}

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';
  if (!date) return '';
  const dateAsDate = new Date(date);
  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, fm, { locale: ptBR });
}

export function fDateISO(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'yyyy-MM-dd';
  if (!date) return '';
  const dateAsDate = new Date(date);
  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, fm, { locale: ptBR });
}

export function fTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'p';
  if (!date) return '';
  const dateAsDate = new Date(date);
  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, fm, { locale: ptBR });
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';
  if (!date) return '';
  const dateAsDate = new Date(date);
  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, fm, { locale: ptBR });
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
        locale: ptBR,
      })
    : '';
}

export function fToNowOrDate(date: InputValue) {
  const fm = 'dd MMM yyyy';
  if (!date) return '';
  const dateAsDate = new Date(date);
  if (!isValid(dateAsDate)) return '';
  if (new Date().getDate() === dateAsDate.getDate()) {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: ptBR,
    });
  }
  return format(dateAsDate, fm, { locale: ptBR });
}

export function isBetween(inputDate: Date | string | number, startDate: Date, endDate: Date) {
  const date = new Date(inputDate);

  const results =
    new Date(date.toDateString()) >= new Date(startDate.toDateString()) &&
    new Date(date.toDateString()) <= new Date(endDate.toDateString());

  return results;
}

export function isAfter(startDate: Date | null, endDate: Date | null) {
  const results =
    startDate && endDate ? new Date(startDate).getTime() > new Date(endDate).getTime() : false;

  return results;
}

export function fDateInput(date: InputValue) {
  if (!date) return '';

  return new Date(`${date}T00:00:00`);
}

export function fHourMinute(time: InputValue) {
  if (!time) return '';


  if (typeof time === 'string' && /^\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(time)) {
    return time.slice(0, 5);
  }

  const dateAsDate = new Date(time);
  if (!isValid(dateAsDate)) return '';
  return format(dateAsDate, 'HH:mm', { locale: ptBR });
}